import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['noise', 'postContainer']

  expandPost() {
    this.expandableSelector.classList.remove('max-h-64', 'overflow-y-clip')
    this.noiseTarget.remove()
  }

  get expandableSelector() {
    return this.postContainerTarget.querySelector('.card')
  }
}
